import React, { useEffect, useState } from 'react';
import tb1 from "../../../images/tb1.png";
import tb2 from "../../../images/tb2.png";
import share from "../../../images/share-img.png";
import search from '../../../images/Search.png';
import { useDispatch, useSelector } from 'react-redux';
import { list_quiz, View_Answer } from "../../../redux/authslice";
import { useNavigate } from 'react-router-dom';
import "./hstry.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";


const History = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listquiz = useSelector((state) => state.counter.listquizs);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(7);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermApplied, setSearchTermApplied] = useState("");

  const handleClick = (id) => {
    localStorage.setItem("id", id);
    navigate("/quizz");
  };

  const viewQuiz = (data) => {
    dispatch(View_Answer({ id: data.id, navigate, dispatch }));
  };


  useEffect(() => {
    dispatch(list_quiz(dispatch));
  }, [dispatch]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleSearchClick = () => {
    setSearchTermApplied(searchTerm);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const filteredQuizzes = listquiz?.filter(
    (quiz) =>
      quiz.name.toLowerCase().includes(searchTerm ? searchTermApplied.toLowerCase() : searchTerm) ||
      (quiz.score && quiz.score.toString().includes(searchTerm ? searchTermApplied : searchTerm)) ||
      (quiz.percentage && quiz.percentage.toString().includes(searchTerm ? searchTerm : searchTermApplied))
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentQuizzes = filteredQuizzes.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredQuizzes?.length / itemsPerPage);

  const renderPagination = () => {
    const showingNumbers = 3;
    const pageNumbers = [];

    pageNumbers.push(
      <li
        key={1}
        className={`page-item ${currentPage === 1 ? "active" : ""}`}
        onClick={() => setCurrentPage(1)}
      >
        <p className="page-link">1</p>
      </li>
    );

    let startPage = Math.max(2, currentPage - Math.floor(showingNumbers / 2));
    let endPage = Math.min(totalPages - 1, currentPage + Math.floor(showingNumbers / 2));

    if (currentPage <= Math.floor(showingNumbers / 2)) {
      endPage = Math.min(totalPages - 1, showingNumbers + 1);
    }

    if (currentPage > totalPages - Math.floor(showingNumbers / 2)) {
      startPage = Math.max(2, totalPages - showingNumbers);
    }

    if (startPage > 2) {
      pageNumbers.push(<li key="start-dots">...</li>);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
          onClick={() => setCurrentPage(i)}
        >
          <p className="page-link">{i}</p>
        </li>
      );
    }

    if (endPage < totalPages - 1) {
      pageNumbers.push(<li key="end-dots">...</li>);
    }

    if (totalPages > 1) {
      pageNumbers.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
          onClick={() => setCurrentPage(totalPages)}
        >
          <p className="page-link">{totalPages}</p>
        </li>
      );
    }

    return (
      <div className="d-flex justify-content-end">
        <ul className="pagination">
          {currentPage > 1 ? (
            <li
              className="page-item prev arrow-icon"
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              &#x2039;
            </li>
          ) : (
            <li className="page-item prev arrow-icon disabled">&#x2039;</li>
          )}
          {pageNumbers}
          {currentPage < totalPages ? (
            <li
              className="page-item next arrow-icon"
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              &#8250;
            </li>
          ) : (
            <li className="page-item next arrow-icon disabled">&#8250;</li>
          )}
        </ul>
      </div>
    );
  };


  return (
    <section className="view-history all-dasboard">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="view-history-content">
              <h3 className="Quizhistoryh3">Quiz history</h3>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="border-tbl">
              <div className="row">
                <div className="col-lg-6">
                  <div className="left-his">
                    <div className="search-34">
                      <input
                        type="search"
                        placeholder="Search for quiz name, answer"
                        className="search-12"
                        value={searchTerm}
                        onChange={handleSearch}
                      />
                      <img src={search} className="Search-img" alt="Search" />
                    </div>
                    <button className="search-bt" onClick={handleSearchClick}>Search</button>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="right-his">
                    <div className="select-div">
                      <p className="View-90">View</p>
                      <select value={itemsPerPage} onChange={handleItemsPerPageChange}>
                        <option value={7}>7 rows</option>
                        <option value={6}>6 rows</option>
                        <option value={5}>5 rows</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="table-div-scrol">
                    <table>
                      <thead>
                        <tr>
                          <th />
                          <th>Subject</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Score</th>
                          <th>% Score</th>
                          <th>Status</th>
                          <th>Actions</th>
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {currentQuizzes.length === 0 ? (
                          <tr>
                            <td colSpan="9" style={{ textAlign: "center" }}>
                              No data
                            </td>
                          </tr>
                        ) : (
                          currentQuizzes.map((quiz, index) => (
                            <tr key={index} >
                              <td>
                                <input type="checkbox" />
                              </td>
                              <td>{quiz?.name}</td>
                              <td>
                                {quiz?.completion_date
                                  ? new Date(quiz?.completion_date * 1000).toLocaleDateString("en-GB")
                                  : "N/A"}
                              </td>

                              <td>
                                {quiz?.completion_date
                                  ? new Date(quiz.completion_date * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                                  : "N/A"}
                              </td>
                              <td>{quiz?.score}</td>
                              <td>{quiz?.percentage ? quiz?.percentage.toFixed(1) + "%" : "N/A"}</td>
                              <td>
                                <p className="Completed-p" style={{ color: quiz?.status === "Completed" ? "green" : "red" }}>{quiz?.status}</p>
                              </td>
                              <td>
                                <div className="complw" style={{ cursor: 'pointer' }} >
                                  <span style={{ padding: "10px", marginTop: "5px" }}>
                                    <FontAwesomeIcon
                                      icon={faEye}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        viewQuiz(quiz);
                                      }}
                                      style={{ color: '#6c757d', fontSize: '20px' }}
                                    />
                                  </span>
                                  <img src={tb1} alt="View" onClick={() => handleClick(quiz?.id)} />
                                  <img src={tb2} alt="Edit" onClick={() => navigate("/feedback", localStorage.setItem("id", quiz?.id)
                                  )}
                                  />

                                </div>
                              </td>
                              <td>
                                <img style={{ width: 20 }} src={share} alt="Share" />
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px", marginBottom: "0px", marginLeft: "20px", color: "grey", fontSize: "14px" }}>
                      Showing {currentPage} - {itemsPerPage} of {totalPages} Entries
                      {renderPagination()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default History
